import { Primitive as o } from "@radix-ui/react-primitive";
import { useLayoutEffect as t } from "@radix-ui/react-use-layout-effect";
import e from "react-dom";
import * as r from "react";
import l from "@babel/runtime/helpers/esm/extends";
export const Portal = /*#__PURE__*/r.forwardRef((a, i) => {
  var n, d;
  const {
      containerRef: s,
      style: u,
      ...c
    } = a,
    m = null !== (n = null == s ? void 0 : s.current) && void 0 !== n ? n : null === globalThis || void 0 === globalThis || null === (d = globalThis.document) || void 0 === d ? void 0 : d.body,
    [, f] = r.useState({});
  return t(() => {
    f({});
  }, []), m ? /*#__PURE__*/e.createPortal(/*#__PURE__*/r.createElement(o.div, l({
    "data-radix-portal": ""
  }, c, {
    ref: i,
    style: m === document.body ? {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 2147483647,
      ...u
    } : void 0
  })), m) : null;
}); /*#__PURE__*/
export const UnstablePortal = /*#__PURE__*/r.forwardRef((t, a) => {
  var i;
  const {
    container: n = null === globalThis || void 0 === globalThis || null === (i = globalThis.document) || void 0 === i ? void 0 : i.body,
    ...d
  } = t;
  return n ? /*#__PURE__*/e.createPortal(/*#__PURE__*/r.createElement(o.div, l({}, d, {
    ref: a
  })), n) : null;
}); /*#__PURE__*/
export const Root = Portal;